import Image from 'next/image';

export default function BgContainerBig({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className='relative flex justify-center p-8'>
      <div className={`relative z-10 border-brand text-white`}>{children}</div>
      <Image
        src='/images/treads.jpg'
        alt=''
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        className='absolute z-0'
      />
    </div>
  );
}
